<script>
    import LayoutGrid, { Cell as LayoutCell } from "@smui/layout-grid";
    import {Subtitle, Title} from "@smui/paper";

    export let span = 4;
    export let cssClass = "no-web";
</script>

<LayoutCell span={span} class="{cssClass}">
    <Title style="font-weight: bold">CONCRETIO</Title>
    <Subtitle>24 rue Feydeau</Subtitle>
    <Subtitle>75002 Paris</Subtitle>
    <Subtitle>SIRET : 50873236900030</Subtitle>
    <Subtitle>Code NAF : 8299Z</Subtitle>
    <br><br>
    <Subtitle>N° SS :</Subtitle>
    <Subtitle>Convention collective : portage salarial (n° 3219)</Subtitle>
</LayoutCell>